export default __webpack_public_path__ + "images/funnelchart.431d0da290171908d0531ad0bf466b6b.svg";